"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var AlertAction_1 = require("@/pages/alert/actions/AlertAction");
var AlertState_init_1 = require("@/pages/alert/states/AlertState.init");
var searchSetToAlertValue_1 = require("@/transformers/searchSetToAlertValue");
exports.alertReducer = function (state, action) {
    if (state === void 0) { state = AlertState_init_1.defaultAlertState; }
    switch (action.type) {
        case typesafe_actions_1.getType(AlertAction_1.default.setMarketUpdate): {
            return __assign(__assign({}, state), { marketUpdate: action.payload });
        }
        case typesafe_actions_1.getType(AlertAction_1.default.setSaveSearchAlertEnabled): {
            var id_1 = action.payload.id;
            var frequency = action.payload.frequency;
            var enabled_1 = frequency === searchSetToAlertValue_1.AlertFrequency.OFF ? false : true;
            var frequencyStr_1 = searchSetToAlertValue_1.frequencyToString(frequency);
            var newSavedSearches = state.savedSearches.map(function (it) {
                if (it.userSearchSetId !== id_1)
                    return it;
                return __assign(__assign({}, it), { notificationEnabled: enabled_1, notificationFrequency: frequencyStr_1 });
            });
            var newFollowingPlaces = state.followingPlaces.map(function (it) {
                if (it.userSearchSetId !== id_1)
                    return it;
                return __assign(__assign({}, it), { notificationEnabled: enabled_1, notificationFrequency: frequencyStr_1 });
            });
            return __assign(__assign({}, state), { savedSearches: newSavedSearches, followingPlaces: newFollowingPlaces });
        }
        case typesafe_actions_1.getType(AlertAction_1.default.setSavedSearches): {
            return __assign(__assign({}, state), { savedSearches: action.payload });
        }
        case typesafe_actions_1.getType(AlertAction_1.default.setFollows): {
            return __assign(__assign({}, state), { followingPlaces: action.payload });
        }
        case typesafe_actions_1.getType(AlertAction_1.default.setIsLoading): {
            return __assign(__assign({}, state), { isLoading: action.payload });
        }
        case typesafe_actions_1.getType(AlertAction_1.default.setSaveSearchSetChannel): {
            return __assign(__assign({}, state), { savedSearches: state.savedSearches.map(function (it) {
                    if (it.notificationId !== action.payload.id)
                        return it;
                    return __assign(__assign({}, it), { notificationChannels: action.payload.channel });
                }) });
        }
        case typesafe_actions_1.getType(AlertAction_1.default.setSaveSearchSetEnabled): {
            return __assign(__assign({}, state), { savedSearches: state.savedSearches.map(function (it) {
                    if (it.notificationId !== action.payload.id)
                        return it;
                    return __assign(__assign({}, it), { notificationEnabled: action.payload.enabled });
                }) });
        }
        case typesafe_actions_1.getType(AlertAction_1.default.setFollowingPlacesChannel): {
            return __assign(__assign({}, state), { followingPlaces: state.followingPlaces.map(function (it) {
                    if (it.notificationId !== action.payload.id)
                        return it;
                    return __assign(__assign({}, it), { notificationChannels: action.payload.channel });
                }) });
        }
        case typesafe_actions_1.getType(AlertAction_1.default.setFollowingPlacesEnabled): {
            return __assign(__assign({}, state), { followingPlaces: state.followingPlaces.map(function (it) {
                    if (it.notificationId !== action.payload.id)
                        return it;
                    return __assign(__assign({}, it), { notificationEnabled: action.payload.enabled });
                }) });
        }
    }
    return state;
};
